import { Pipe, PipeTransform } from '@angular/core';
import { OrgaentityType } from '@dep/common/core-api/types/orgaentity.type';
import { IOrgaentityClient, IOrgaentityTreeItem } from '@dep/common/interfaces';

@Pipe({
  name: 'locationHasShowroomConnect',
  standalone: false,
})
export class LocationHasShowroomConnectPipe implements PipeTransform {
  /**
   * Checks if a location has a ShowroomConnect child.
   *
   * @param row - The current row item to check.
   * @param tree - The entire tree of items to find the parent location.
   * @returns True if the location has a ShowroomConnect child, otherwise false.
   */
  public transform(row: IOrgaentityTreeItem, tree: IOrgaentityTreeItem[]): boolean {
    if (row.item.type === OrgaentityType.Location && row.item.children) {
      return row.item.children.some(
        (child) => child.type === OrgaentityType.ShowroomConnect,
      );
    } else if (row.item.type === OrgaentityType.Client) {
      const parentLocation = tree.find(
        (item) => item.item.id === (row.item as IOrgaentityClient).parentOrgaentityId && item.item.type === OrgaentityType.Location,
      );
      if (parentLocation) {
        return parentLocation.item.children?.some((child) => child.type === OrgaentityType.ShowroomConnect) || false;
      }
    }

    return false;
  }
}
